// Capitalization of string

import { da } from "date-fns/locale";
import dayjs from "dayjs";
import { PARKING_PLACE_OBJECT_KEYS } from "./constants";

// Get chip background color

function invertColor(hex) {
  if (hex.indexOf("#") === 0) {
    hex = hex.slice(1);
  }
  // convert 3-digit hex to 6-digits.
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  if (hex.length !== 6) {
    throw new Error("Invalid HEX color.");
  }
  // invert color components
  var r = (255 - parseInt(hex.slice(0, 2), 16)).toString(16),
    g = (255 - parseInt(hex.slice(2, 4), 16)).toString(16),
    b = (255 - parseInt(hex.slice(4, 6), 16)).toString(16);
  // pad each with zeros and return
  return "#" + padZero(r) + padZero(g) + padZero(b);
}

function padZero(str, len) {
  len = len || 2;
  var zeros = new Array(len).join("0");
  return (zeros + str).slice(-len);
}

// Get task state description
export const getErrorMessage = (error, t) => {
  console.log("getErrorMessage", error);
  const err = error?.response?.data?.errorCode;
  const message = error?.response?.data?.message;
  const parrams = error?.response?.data?.errorParams;
  if (err) {
    return t(err, { args: parrams[0] });
  }
  if (message) {
    return t(message);
  } else {
    return t("UNKNOWN_ERROR");
  }
};

export const isComponentVisibleForUser = (componentUseCase, userUseCases) => {
  if (userUseCases) {
    let tmp = userUseCases[componentUseCase];
    return tmp;
  } else return true;
};

export const isComponentEnabledForUser = (componentUseCase, userUseCases) => {
  if (userUseCases)
    return (
      userUseCases[componentUseCase] && userUseCases[componentUseCase].execute
    );
  else return true;
};

export const getCodeList = () => { };

export const convertDateToISOString = (date) => {
  date = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  date = date.toISOString().slice(0, 10);
  return date;
};

export const dayjsToDateString = (date, locale) => {
  return date.locale(locale).format("dd DD MMM YY");
};
export const dayjsToTimeString = (date, locale) => {
  return date.locale(locale).format("LT");
};

export const dayjsToNumberDayAndTimeArray = (date, locale) => {
  const day = date.locale(locale).format("DD|MM|YYYY");
  const time = date.locale(locale).format("HH:mm");
  const dayArr = day.split("|");
  let dayStr = "";
  dayArr.forEach((d, i) => {
    if (dayStr.length > 0) {
      dayStr += " ";
    }
    if (d[0] === "0") {
      d = d.split("");
      d.forEach((l, i) => {
        if (i !== 0) {
          dayStr += l;
        }
      });
    } else {
      dayStr += d;
    }
    if (i !== dayArr.length - 1) {
      dayStr += ".";
    }
  });
  let timeStr = "";
  // if (time[0] === "0") {
  //   time = time.split("");
  //   time.forEach((l, i) => {
  //     if (i !== 0) {
  //       timeStr += l;
  //     }
  //   });
  // } else {
  timeStr = time;
  // }
  console.log(dayStr, timeStr);
  return [dayStr, timeStr];
};

export const dayjsToDateTimeString = (date, locale) => {
  return date.locale(locale).format("dd DD MMM YY HH:mm");
};

export const dateTimetoIso = (date) => {
  return new Date(date).toLocaleDateString('cs-CS') + ' ' + new Date(date).toLocaleTimeString('cs-CS');
}

export const getDateMonthAgo = () => {
  const date = new dayjs();
  return date.month(date.month() - 1);
}

export const camelToSnakeCase = str => str.replace(/[a-z][A-Z]/g, letters => `${letters[0].toLowerCase()}_${letters[1].toLowerCase()}`);

export const prepareExportCsv = (records, t, i18n) => () => {
  if (records.length === 0)
    return [[t("NO_RECORD")]];
  const recordKeys = Object.keys(records[0]).filter(key => typeof records[0][key] !== 'object');
  const outerKeys = recordKeys.map(e => t(camelToSnakeCase(e).toUpperCase()));
  const innerKeys = PARKING_PLACE_OBJECT_KEYS.map(e => e === "name" ? t("PLACE") : t(camelToSnakeCase(e).toUpperCase()));
  const header = [[...outerKeys, ...innerKeys]];

  const content = records.map(item => {
    const outerValues = recordKeys.map(key => typeof item[key] === 'string' && i18n.exists(item[key]) ? t(item[key]) : item[key]);
    const innerValues = PARKING_PLACE_OBJECT_KEYS.map(key => {
      return typeof item.parkingPlace[key] === 'string' && i18n.exists(item.parkingPlace[key]) ? t(item.parkingPlace[key]) : item.parkingPlace[key];
    });
    return [...outerValues, ...innerValues];
  });
  return header.concat(content);
}

export const truncateForDisplay = (text, maxLength) => {
  return text != null && text?.length > maxLength ? text.slice(0, maxLength) + "…" : text;
}
